import { Order, OrderStatusStep, OrderTracking } from '@api/order/order.models';

export interface OrderStatusState {
    step: OrderStatusStep;
    orderStatus: Order | OrderTracking;
    orderNumber: string;
}

export const OrderStatusInitialState: OrderStatusState = {
    step: 0,
    orderStatus: null,
    orderNumber: null,
};
